<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">{{ pageTitle }}</div>
							<!--页头-->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										User accounts are for individual use only. The User ID and
										password together constitute the user's electronic signature
										and are used to verify the user's identity when modifying
										system information.<br />
										Every user of this system should have a unique account.
										Users must never share their User ID or password with
										others.<br />
										The system administrator should immediately assign the
										necessary roles to each user so that they are authorized to
										perform all required operations using their personal
										account.
									</div>
								</div>
								<div class="btn_el">
									<div class="tips">
										The User ID and password are used to authenticate users on
										the login page and access the system.<br />
										Please complete the user's full name, email address,
										company, and department according to the actual
										situation.<br />
										If any of this information changes, the user should be
										notified.
									</div>
								</div>
								<div class="form_box">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
										<div class="input_el">
											<div class="tit required">User ID</div>
											<el-form-item label="" prop="user_id">
												<el-input v-model="ruleForm.user_id" placeholder="Please enter"
													clearable></el-input>
											</el-form-item>
										</div>
										<div class="input_el">
											<div class="tit required">User Name</div>
											<el-form-item label="" prop="username">
												<el-input v-model="ruleForm.username" placeholder="Please enter"
													clearable></el-input>
											</el-form-item>
										</div>
										<div class="input_el">
											<div class="tit required">Email Address</div>
											<el-form-item label="" prop="email">
												<el-input v-model="ruleForm.email" placeholder="Please enter"
													clearable></el-input>
											</el-form-item>
										</div>
										<!-- <div class="input_el">
                      <div class="tit required">Company</div>
                      <el-form-item label="" prop="company_id">
                        <el-select
                          v-model="ruleForm.company_id"
                          placeholder="Please select"
                          style="width: 100%"
                          @change="getDepartment(ruleForm.company_id)"
                        >
                          <el-option
                            v-for="value in companyList"
                            :key="value.id"
                            :label="value.company_name"
                            :value="value.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div> -->
										<div class="input_el">
											<div class="tit required">Department</div>
											<el-form-item label="" prop="departments_id">
												<el-select v-model="ruleForm.departments_id" placeholder="Please select"
													style="width: 100%">
													<el-option v-for="value in departmentsList" :key="value.id"
														:label="value.departments_name" :value="value.id"></el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="btn_el">
											<div class="tips">
												Specify which modules or permissions the user is
												authorized to access.
											</div>
										</div>
										<div class="input_el">
											<div class="tit required">Document Management</div>
											<el-form-item label="" prop="is_file">
												<el-select v-model="ruleForm.is_file" placeholder="Please select"
													style="width: 100%">
													<el-option label="Yes" :value="1"></el-option>
													<el-option label="No" :value="2"></el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="input_el">
											<div class="tit required">CAPA</div>
											<el-form-item label="" prop="is_capa">
												<el-select v-model="ruleForm.is_capa" placeholder="Please select"
													style="width: 100%">
													<el-option label="Yes" :value="1"></el-option>
													<el-option label="No" :value="2"></el-option>
												</el-select>
											</el-form-item>
										</div>
										<div class="input_el">
											<div class="tit required">Training Management</div>
											<el-form-item label="" prop="is_train">
												<el-select v-model="ruleForm.is_train" placeholder="Please select"
													style="width: 100%">
													<el-option label="Yes" :value="1"></el-option>
													<el-option label="No" :value="2"></el-option>
												</el-select>
											</el-form-item>
										</div>
										<!-- <div class="input_el">
											<div class="tit">系统管理</div>
											<el-form-item label="" prop="is_config">
												<el-select v-model="ruleForm.is_config" placeholder="请选择" style="width: 100%;">
													<el-option label="是" value="1"></el-option>
													<el-option label="否" value="2"></el-option>
												</el-select>
											</el-form-item>
										</div> -->
										<div v-if="pageTitle == 'Add User'" class="btn_el">
											<div class="tips">
												Please set a login password for this user and ask the
												user to change it after the first successful login.<br />
												The password you set must meet the following
												requirements:<br />
												&nbsp;&nbsp;● Must contain at least 6 characters.<br />
												&nbsp;&nbsp;● Must contain at least one letter.<br />
												&nbsp;&nbsp;● Must contain at least one number.
											</div>
										</div>
										<div v-if="pageTitle == 'Add User'" class="input_el">
											<div class="tit required">Password</div>
											<el-form-item label="" prop="pwd">
												<el-input v-model="ruleForm.pwd" placeholder="Please enter" clearable
													show-password></el-input>
											</el-form-item>
										</div>
										<div v-if="pageTitle == 'Add User'" class="input_el">
											<div class="tit required">Confirm Password</div>
											<el-form-item label="" prop="pwd2">
												<el-input v-model="ruleForm.pwd2" placeholder="Please enter" clearable
													show-password></el-input>
											</el-form-item>
										</div>
									</el-form>
								</div>
								<div class="btn_box">
									<van-button class="btn_el" type="default" round @click="cancel">Cancel</van-button>
									<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
										@click="submitForm('ruleForm')">Save</van-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		usersAdd,
		usersEdit,
		usersDetail
	} from "@/api/system/user";
	// import { companyList } from "@/api/system/company";
	import {
		departmentsList
	} from "@/api/system/department";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import md5 from "js-md5";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				pageTitle: "",
				ruleForm: {
					user_id: "",
					username: "",
					email: "",
					// is_config: '',
					is_file: 1,
					is_train: 1,
					is_capa: 1,
					// company_id: "",
					departments_id: "",
					pwd: "",
					pwd2: "",
				},
				rules: {
					user_id: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					username: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					email: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					pwd: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					pwd2: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					is_file: [{
						required: true,
						message: "Please select",
						trigger: "change"
					}],
					is_train: [{
						required: true,
						message: "Please select",
						trigger: "change"
					}],
					is_capa: [{
						required: true,
						message: "Please select",
						trigger: "change"
					}],
					// company_id: [{
					// 	required: true,
					// 	message: "Please select",
					// 	trigger: "change"
					// }],
					departments_id: [{
						required: true,
						message: "Please select",
						trigger: "change"
					}, ],
				},
				// companyList: [],
				departmentsList: [],
			};
		},
		created() {
			let that = this;
			// companyList({
			// 	page: 1,
			// 	page_size: 9999,
			// 	status: 1,
			// 	company_name: "",
			// 	company_userid: "",
			// 	manage_userid: "",
			// }).then((res1) => {
				// that.companyList = res1.data.data;
				that.isLoading = false;
				if (that.$route.query.oid) {
					that.pageTitle = "Edit User";
					that.$toast.loading({
						duration: 0,
						forbidClick: true
					});
					usersDetail({
						id: that.$route.query.oid
					}).then((res) => {
						that.$toast.clear();
						if (res.code == 200) {
							that.ruleForm = {
								user_id: res.data.user_id,
								username: res.data.username,
								email: res.data.email,
								is_file: res.data.is_file,
								is_train: res.data.is_train,
								is_capa: res.data.is_capa,
								// company_id: res.data.company_id ? res.data.company_id : "",
								departments_id: res.data.departments_id ?
									res.data.departments_id :
									"",
							};
							// if (that.ruleForm.company_id) {
								that.getDepartment(res.data.departments_id);
							// }
						} else {}
					});
				} else {
					that.pageTitle = "Add User";
					that.getDepartment();
				}
			// });
		},
		mounted() {
			let that = this;
			that.isLoading = false;
		},
		watch: {
			//
		},
		methods: {
			//获取部门
			getDepartment(val) {
				let that = this;
				that.ruleForm.departments_id = "";
				that.departmentsList = [];
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});
				departmentsList({
					page: 1,
					page_size: 9999,
					status: 1,
					departments_name: "",
					// company_id: value,
					departments_userid: "",
				}).then((res2) => {
					that.$toast.clear();
					that.departmentsList = res2.data.data;
					if (val) {
						that.ruleForm.departments_id = val;
					}
				});
			},
			//取消
			cancel() {
				this.$router.back();
			},
			//保存
			submitForm(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						//校验邮箱
						if (
							!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
								that.ruleForm.email
							)
						) {
							that.$message("Invalid email format");
							return false;
						}
						if (that.pageTitle == "Add User") {
							//校验密码
							if (that.ruleForm.pwd != that.ruleForm.pwd2) {
								that.$message("Please set the user's password correctly.");
								return false;
							}
							if (!/^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(that.ruleForm.pwd)) {
								that.$message("Invalid password format");
								return false;
							}
							that.$toast.loading({
								duration: 0,
								forbidClick: true
							});
							usersAdd({
								user_id: that.ruleForm.user_id,
								username: that.ruleForm.username,
								email: that.ruleForm.email,
								is_file: that.ruleForm.is_file,
								is_train: that.ruleForm.is_train,
								is_capa: that.ruleForm.is_capa,
								// company_id: that.ruleForm.company_id,
								departments_id: that.ruleForm.departments_id,
								password: md5(that.ruleForm.pwd + "AiisoQms2026"),
							}).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message.success("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								} else {}
							});
						} else if (that.pageTitle == "Edit User") {
							that.$toast.loading({
								duration: 0,
								forbidClick: true
							});
							usersEdit({
								id: that.$route.query.oid,
								user_id: that.ruleForm.user_id,
								username: that.ruleForm.username,
								email: that.ruleForm.email,
								is_file: that.ruleForm.is_file,
								is_train: that.ruleForm.is_train,
								is_capa: that.ruleForm.is_capa,
								// company_id: that.ruleForm.company_id,
								departments_id: that.ruleForm.departments_id,
								password: that.ruleForm.pwd,
							}).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message.success("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								} else {}
							});
						}
					} else {
						return false;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_box {
				text-align: center;

				.btn_el {
					margin-left: 10px;
					padding: 12px 24px;

					.van-button__text {
						font-size: 16px;
					}
				}
			}

			.form_box {
				.input_el {
					.tit {
						padding-bottom: 5px;
						font-size: 14px;
						color: #333333;
					}

					.required::before {
						content: "*";
						color: red;
						margin-right: 2px;
					}
				}
			}

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}
</style>